import getTotalRemainingSeconds from './getTotalRemainingSeconds';

export default (endTime: number, date: Date): number => {
  return Math.round(getTotalRemainingSeconds(endTime, date)) % 60;
};
